// extracted by mini-css-extract-plugin
module.exports = {"signup":"_SignUpForm_signup_Ghryu","link":"_SignUpForm_link_2DTbC"};